<template>
	<div class="publish_item position-relative">
		<div class="base_info">
			<span class="title" style="font-size: 1rem;font-weight: bold;position: relative">基本信息</span>
			<div class="upload_main_pic" style="margin-top: 1.56rem;">
				<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;">
					<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">上传产品主图</span>
				</div>
				<div class="d-flex a-center flex-wrap">
					<img style="width: 7.5rem;height: 7.5rem;border-radius: 6px;" :src="goodsmsg.goods_img" v-if="goodsmsg.goods_img" alt="">
				</div>
			</div>
			<div class="item_title" style="margin-top: 2.75rem;">
				<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;">
					<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">产品标题</span>
				</div>
				<input type="text" placeholder="请输入产品标题最多30个字" v-model="goodsmsg.goods_name" style="width: 48.44rem;height: 1.88rem;padding: 0 1.06rem;box-sizing: border-box; border:1px solid #1E69FF;border-radius: 4px; outline-color: #1E69FF;margin: 0 auto;display:block;">
			</div>
			<div class="specification" style="margin-top: 2.75rem;" v-if="goodsmsg.product_img">
				<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;">
					<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">规格参数</span>
				</div>
				<img style="width: 7.5rem;height: 7.5rem;border-radius: 6px;" :src="goodsmsg.product_img" alt="">
			</div>
			<div class="item_detail" style="margin-top: 2.75rem;">
				<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;">
					<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">产品详情</span>
				</div>
				<div style="width: 48.44rem;height: 53.5rem;margin: 0 auto;border: 2px solid #BBBBBB;border-radius: 4px;position: relative;">
					<div style="width: 100%;height: 50.3rem;overflow-y: scroll;">
						<div v-for="(item,index) in goodsmsg.desc_mobile">
							<img style="width: 100%;" :src="item" alt="">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="sale_property d-flex" style="margin-top: 3.69rem;justify-content: flex-start;">
			<div class="unify_price" style="margin-top: 1.56rem;margin-right: 3.75rem;">
				<div style="margin-bottom: 1.19rem;">
					<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">产品定价:</span>
					<input v-model="goodsmsg.shop_price" type="text" disabled style="max-width: 10.3rem;height: 1.88rem;text-align: center;border-radius: 4px;border: 2px solid #BBBBBB;outline: none;margin-left: 1.5rem;">元
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				goodsmsg : '',
				id : '',
				shop_price : ''
			}
		},
		methods: {
			getoptionalMsg(){
				let param = {
					act : 'goods_optional_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					gop_id : this.id
				}
				this.$api.goods_list(param).then((res)=>{
					console.log(res.data);
					if(res.code == 0){
						this.goodsmsg = res.data
					}else{
						this.$message({
							type : 'error',
							message : res.msg
						})
					}
				})
			}
		},
		mounted() {
			this.id = this.$route.params.id
			this.getoptionalMsg()
		}
	}
</script>

<style lang="scss">
	.el-cascader-menu {
		width: 33.3%;
	}

	.el-cascader-node {
		padding: 0 2rem 0 1rem !important;
	}

	.el-cascader {
		.el-input__inner {
			font-size: 0.75rem;
		}
	}

	.in-active-path {
		color: #1E69FF !important;
		background: #EEF4FF !important;

		&::before {
			content: '';
			width: 0.13rem;
			height: 1.25rem;
			background: #1E69FF;
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
		}
	}

	.is-active {
		color: #1E69FF !important;
		background: #EEF4FF !important;
	}

	.el-scrollbar__wrap {
		overflow: auto !important;
		margin-right: -6px !important;
	}

	.el-scrollbar__view,
	.el-cascader-menu__list {
		padding: 0 !important;
	}




	.avatar-uploader {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;
	}

	.el-upload--text {
		width: 100%;
		height: 100%;
	}

	.avatar-uploader:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100%;
		height: 100%;
		line-height: 100%;
		text-align: center;
	}

	.avatar {
		width: 7.5rem;
		height: 7.5rem;
		display: block;
	}

	.el-upload-list--picture {
		position: absolute;
		left: 0;
		top: 3.13rem;
		width: 100% !important;

		.el-upload-list__item,
		.is-success {
			width: 100% !important;
			height: 100% !important;
		}
	}

	.el-progress,
	.el-progress--circle,
	.el-progress-circle {
		width: 100% !important;
		height: 100% !important;
	}
</style>
<style lang="scss" scoped>
	::-webkit-scrollbar {
	  display: none; /* Chrome Safari */
	}
	.text-suojin{
		 overflow: hidden;
		 text-overflow: ellipsis;
		 display: -webkit-box; 
		 -webkit-line-clamp: 2;
		 -webkit-box-orient: vertical;
	}
	.tableHead div:first-child{
		border-left: 2px solid #BBBBBB;
	}
	.tableBody div{
		border-top: 0px solid #BBBBBB !important;
	}
	input[type="checkbox"] {
		width: 1.13rem;
		height: 1.13rem;
		-webkit-appearance: none;
		border: 1px solid #c9c9c9;
		border-radius: 10px;
		outline: none;
		cursor: pointer;
	}

	input[type=checkbox]:checked {
		background: url("../../assets/itemStore/xuanzhong@2x.png")no-repeat;
		background-size: 100% 100%;
	}

	.publish_item {
		max-width: 73.13rem;
		box-sizing: border-box;
		margin: 1.25rem auto;
		background: #FFFFFF;
		padding: 1.81rem 0 3.63rem 0;

		.title::before {
			content: '';
			background: url(../../assets/itemStore/biaoqian@2x.png) no-repeat;
			background-size: 100%;
			width: 0.94rem;
			height: 1.19rem;
			position: absolute;
			left: -1.3rem;
			top: 50%;
			transform: translate(0, -50%);
		}

		.second_title::before {
			content: '';
			background: url(../../assets/itemStore/xiaobiao@2x.png) no-repeat;
			background-size: 100%;
			width: 0.44rem;
			height: 0.44rem;
			position: absolute;
			left: -1rem;
			top: 50%;
			transform: translate(0, -50%);
		}


		.sale_data {
			position: relative;
			width: 48.44rem;
			margin: 0 auto;

			.selected {}

			.select {
				height: 20rem;
			}
		}

		.base_info {
			width: 48.44rem;
			margin: 0 auto;
			margin-top: 3rem;
		}

		.sale_property {
			width: 48.44rem;
			margin: 0 auto;
		}

		.buttons {
			width: 48.44rem;
			margin: 0 auto;
			margin-top: 3.88rem;

			.button {
				width: 10.3rem;
				height: 1.8rem;
				border-radius: 0.9rem;
				text-align: center;
				line-height: 1.8rem;
				font-size: 0.75rem;
				border: 2px solid #000000;
				cursor: pointer;
			}
		}
	}
</style>
